import CommonIFrame from '../atoms/CommonIFrame';

const AssortmentPerformanceRanking = () => {
    return (
        <CommonIFrame
            src="https://asifhedifh-asoiahfie918-andid.lovable.app"
            title="Assortment Scorecard"
        />
    );
};

export default AssortmentPerformanceRanking;
